import { setStudioView } from '../workspace/studio-views';
import { ConceptWorkspace, type ConceptWorkspaceProps } from './ConceptWorkspace';
import { ConceptCreate, type ConceptCreateProps } from './ConceptCreate';
export function mountConceptWorkspace(_host:HTMLElement,props:ConceptWorkspaceProps){setStudioView('app',`concept:${props.project.id}`,<ConceptWorkspace key={props.project.id} {...props}/>)}
export function mountConceptCreate(props:ConceptCreateProps){setStudioView('concept-create','concept-create',<ConceptCreate {...props}/>)}
